










import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';

import LoraForwarderChirpStackStore from '@/store/lora/LoraForwarderChirpStack.store';

import LoraForwarderStats from '@/components/Lora/Forwarder/LoraForwarderStats.vue';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {LoraForwarderStats},
})
export default class LoraForwarderChirpStackStatus extends Mixins<BaseComponent>(BaseComponent) {
  private forwarderStore: LoraForwarderChirpStackStore = getModule(LoraForwarderChirpStackStore, this.$store);

}
